export default "__VITE_ASSET__BejHTYts__"